import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { Tag } from '@examdojo/tags';
import { QuestionBankStoreModel } from '../data/question-bank-store.model';
import {
  MarksRange,
  Pagination,
  QuestionBankFilters,
  QuestionBankSortOption,
  QuestionTagMap,
} from './question-bank.model';

export type QuestionBankState = EntityState<
  QuestionBankStoreModel,
  {
    syllabusId: number;
    classId?: string;
    courseLevel?: string | null;
    filters: QuestionBankFilters;
    pagination: Pagination;
    total: number;
    facets: Record<string, number>;
    questionTagMap: QuestionTagMap;
    sortBy: QuestionBankSortOption;
    marksRange: MarksRange;
    tags: Tag[];
  },
  number
>;

export const INIT_QUESTION_BANK_MARKS_RANGE: MarksRange = { min: -1, max: -1 };
export const INIT_QUESTION_BANK_FILTERS: QuestionBankFilters = {
  topicMatchMode: 'ANY',
  completed: false,
};
export const INIT_QUESTION_BANK_PAGINATION: Pagination = {
  pageSize: 10,
  page: 1,
};

@Injectable({ providedIn: 'root' })
export class QuestionBankStore extends EntityStore<QuestionBankState, QuestionBankStoreModel, 'id', number> {
  constructor() {
    super({
      name: 'question-bank',
      idKey: 'id',
      initialPropsState: {
        syllabusId: 0,
        classId: undefined,
        courseLevel: undefined,
        filters: INIT_QUESTION_BANK_FILTERS,
        sortBy: QuestionBankSortOption.MostRelevant,
        pagination: INIT_QUESTION_BANK_PAGINATION,
        total: 0,
        facets: {},
        questionTagMap: {},
        marksRange: INIT_QUESTION_BANK_MARKS_RANGE,
        tags: [],
      },
    });
  }
}
